import { useState } from "react"
import {Button, Skeleton, Dropdown, Space} from "antd"
import Slider from "react-slick"
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import "./index.css"

const TopBar= () => {
    const loading= true
    const [current, setCurrent]= useState(0)
    var businesspartner = {
        dots: false,
        // infinite: playlists?.length>4,
        speed: 800,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        autoplay:false,
        
        responsive: [
          {
            breakpoint: 1150,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 855,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
            }
          },
          {
            breakpoint: 786,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 569,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
        ]
      }
    return (
        <div className='playlist py-4 border-bottom-black'>
                  <div>
                    <Space>
                        <Button 
                            onClick={()=>{setCurrent(0)}}
                            size='large'
                            type={current===0?'primary':'default'}
                            disabled={loading}
                            >
                            Draft
                        </Button>
                        <Button 
                            onClick={()=>{setCurrent(1)}}
                            size='large'
                            type={current===1?'primary':'default'}
                            disabled={loading}
                            >
                              afasf
                        </Button>
                    </Space>
                  </div>
                  <div>
                    {
                        loading ?
                        <div className='width-100'>
                            <Slider {...businesspartner}>
                                {
                                    new Array(8)?.fill(null)?.map((_, index)=>
                                        <div className='w-100 m-0'>
                                            <div className='px-2'>
                                                <Skeleton.Button 
                                                    active 
                                                    size='large' 
                                                    shape={'square'} 
                                                    block
                                                    style={{width:'100%', height:'40px'}}
                                                    className='radius-6'
                                                    key={'skelton-'+index}
                                                    />
                                            </div>
                                        </div>
                                    )
                                }
                            </Slider>
                        </div>
                        :
                        <div className='width-100'>
                            <Slider {...businesspartner}>
                                {
                                  []?.map(( playlist, index)=>
                                    <div key={'playlist-'+index}>
                                      <div className='px-2'>
                                        <Dropdown.Button
                                          menu={{
                                            items:[
                                              {
                                                key: '1',
                                                label: <DeleteOutlined className='red-5'/>,
                                              },
                                              {
                                                key: '2',
                                                label: <EditOutlined className='secondary-color'/>,
                                              }
                                            ]
                                          }}
                                          className='playlist-button'
                                          type={current===(index+2)?'primary':'default'}
                                          size='large'
                                          >
                                          {
                                            playlist?.name
                                          }
                                        </Dropdown.Button>
                                      </div>
                                    </div>
                                  )
                                }
                            </Slider>
                        </div>
                    }
                  </div>
                </div>
    )
}
export {TopBar}